import axios from "axios";
import GmapVue from 'gmap-vue';
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import 'tiptap-vuetify/dist/main.css';
import VueMask from "v-mask";
import Vue from "vue";
import VueCookies from 'vue-cookies';
import { SimpleSVG } from 'vue-simple-svg';
import 'vuetify/dist/vuetify.min.css';
import App from "./App.vue";
import { JWTTokenRequestInterceptor, SessionExpiredInterceptor } from "./interceptors/jwttokenrequest.interceptor";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";

const iconsGroup = localStorage.getItem("current_icons_group") || "mdi";

axios.defaults.baseURL = process.env.VUE_APP_URL;

axios.interceptors.request.use(JWTTokenRequestInterceptor);
axios.interceptors.response.use(undefined, SessionExpiredInterceptor);

Vue.use(VueMask);
Vue.use(VueCookies);
Vue.use(TiptapVuetifyPlugin, {
    vuetify,
    iconsGroup
});
Vue.component('simple-svg', SimpleSVG)

Vue.use(GmapVue, {
    load: {
        key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
        libraries: 'places',
    },
    installComponents: true,
    dynamicLoad: false,
});

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
    async mounted() {
        await store.dispatch("AppConfig/carregarConfiguracoesApp", { root: true });

        // Crrega o usuário logado
        await store.dispatch("Auth/loadLoggedUser", { root: true });

        // Carrega o dispositivo atual no usuário
        store.commit('User/device', { root: true });

        store.dispatch('Pedido/buscarPedidoEdicao', { root: true });
    }
}).$mount("#app");
